var map = {
	"./about.json": "adb7",
	"./areas.json": "2fb7",
	"./areas_district_available_days.json": "e6b3",
	"./banners.json": "272a",
	"./branches.json": "0f92",
	"./cancel_reasons.json": "31d4",
	"./companies.json": "cff4",
	"./contacts.json": "88ee",
	"./customers.json": "ee22",
	"./delivery_app_version.json": "f920",
	"./delivery_men.json": "e6e5",
	"./dm_weight_targets.json": "9877",
	"./filter.json": "a90f",
	"./integrations.json": "6de4",
	"./inventories.json": "a9ab",
	"./inventory_logs.json": "c7d7",
	"./menu.json": "aaecc",
	"./notifications_sub.json": "fb2c",
	"./order_notes.json": "5725",
	"./order_status.json": "0a3c",
	"./orders.json": "78a4",
	"./popups.json": "2dde",
	"./ref_roles.json": "54d9",
	"./status.json": "7a01",
	"./tickets.json": "b227",
	"./tickets_replayes.json": "1e7c",
	"./tickets_status.json": "0274",
	"./user_roles.json": "2a0a",
	"./user_roles_permissions.json": "8520",
	"./users.json": "036f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a3cb";